<template>
  <div>
    <h2>Terminübersicht</h2>

    <div class="input-group my-4 col-lg-5 p-0">
      <div class="input-group-prepend">
        <div class="input-group-text">Termin</div>
      </div>
      <select v-model="dateTypeId" class="form-control">
        <option v-for="(elem,idx) in this.dateTypes" :key="idx" :value="elem.id">
          {{ elem.sName }}
        </option>
      </select>
    </div>

    <table v-once v-bind:id=tableId class="dataTable table table-striped table-bordered" width="100%" cellspacing="0">
      <thead>
      <tr>
        <th>Optionen</th>
        <th>Nachname</th>
        <th>Vorname</th>
        <th>Datum</th>
        <th>Überwachung deaktivieren</th>
        <th>Status</th>
        <th>Letzte Erinnerung</th>
      </tr>
      </thead>
    </table>
  </div>

</template>

<script>
/* global $ */

import DateService from '../services/DateService'

export default {
  name: 'UserDates',
  data () {
    return {
      dateTypes: [],
      dateTypeId: -1,
      // eslint-disable-next-line no-undef
      tableId: 'dTable_' + this.$func.uuid()
    }
  },
  computed: {
    getDateTypeId () {
      return this.dateTypeId
    }
  },
  watch: {
    'getDateTypeId' (newval, oldval) {
      if (oldval === -1) return true
      $('#' + this.tableId).dataTable().api().ajax.url('/moduls_new/date/datetype/' + this.dateTypeId + '/').load()
    }
  },
  async mounted () {
    var tmp = await DateService.getUserDateTypes()
    this.dateTypes = tmp.data

    if (this.dateTypes.length > 0) {
      this.dateTypeId = this.dateTypes[0].id
    }
    var tableId = this.tableId
    var self = this
    var path = '/date/datetype/' + this.dateTypeId + '/'
    var editorpath = '/date/'

    this.$func.loadDatatable(
      () => $(document).ready(function () {
        var editor = new $.fn.dataTable.Editor({
          ajax: {
            create: self.$func.addAuth({
              type: 'POST',
              url: editorpath
            }),
            edit: self.$func.addAuth({
              type: 'PUT',
              url: editorpath + '_id_/'
            }),
            remove: self.$func.addAuth({
              type: 'DELETE',
              url: editorpath + '_id_/',
              deleteBody: false
            })
          },
          idSrc: 'id',
          table: '#' + tableId,
          fields: [{
            label: 'Überwachung deaktivieren:',
            name: 'bSkip',
            type: 'checkbox',
            options: {
              '': '1'
            },
            separator: ','
          }, {
            label: 'Datum:',
            name: 'sDate',
            type: 'datetime',
            format: 'DD.MM.YYYY'
          }, {
            label: 'Type:',
            name: 'oDateType',
            type: 'hidden'
          }, {
            label: 'entity:',
            name: 'lEntityID',
            type: 'hidden'
          }
          ]
        })

        editor.on('preOpen', function (e, mode, action) {
          var rowData = $('#' + tableId).DataTable().row(this.modifier()).data()
          editor.set('oDateType', rowData.oDateType.id)
        })

        $('#' + tableId).on('click', 'tbody td', function (e) {
          var index = $(this).index()
          if (index == 0) return
          if (index == 4) {
            editor.bubble(this, ['bSkip'])
          } else if (index == 3) {
            editor.bubble(this, ['sDate'])
          } else {
            editor.bubble(this, ['bSkip', 'sDate'])
          }

          editor.buttons({
            label: $.fn.dataTable.Editor.defaults.i18n.edit.submit,
            className: 'btn btn-primary',
            fn: function () {
              editor.submit()
            }
          })
        })

        $('#' + tableId).DataTable({
          dom: 'BfQrtip', // BUTTON/FIND/PROCESSING/TABLE/INFO/PAGING
          ajax: self.$func.addAuth({
            url: path,
            type: 'GET'
          }),
          scrollX: true,
          scrollCollapse: true,
          order: [[1, 'asc']],
          rowCallback: function (row, data, index) {
            if (data.bSkip) {
              $('td', row).addClass('alert-dark')
              return true
            } else {
              $('td', row).removeClass('alert-dark')
            }
            if (data.sStatus == 'Warnung') {
              $('td', row).removeClass('alert-warning').removeClass('alert-success').addClass('alert-danger')
            } else if (data.sStatus == 'Erinnerung') {
              $('td', row).removeClass('alert-danger').removeClass('alert-success').addClass('alert-warning')
            } else {
              $('td', row).removeClass('alert-danger').removeClass('alert-warning').addClass('alert-success')
            }
          },
          columns: [
            {
              class: 'center not-export-col w100',
              data: null,
              render: function (data, type, row) {
                // eslint-disable-next-line no-unused-vars
                var edit = '<i title="Bearbeiten" class="dt-edit fas fa-pen fa-lg pointer text-secondary"></i>'
                var history = '<i title="Historie" class="dt-history fas fa-history fa-lg pointer text-secondary"></i>'

                return edit + history
              }
            },
            {
              class: 'center',
              data: 'oUser.sLastname'
            },
            {
              class: 'center',
              data: 'oUser.sFirstname'
            },
            {
              class: 'center',
              data: 'sDate'
            },
            {
              class: 'center w100',
              data: null,
              render: function (data, type, row) {
                return (data.bSkip == '1') ? 'X' : ''
              }
            }, {
              class: 'center',
              data: null,
              render: function (data, type, row) {
                return data.sStatus
              }
            }, {
              class: 'center w100',
              data: 'sLastReminder'
            }
          ],
          buttons: self.$func.addDefaultButtons([])
        })

        $('#' + tableId).on('click', '.dt-edit', function (e) {
          editor
            .edit($(this).closest('tr'))
            .title($.fn.dataTable.Editor.defaults.i18n.edit.title)
            .buttons({
              label: $.fn.dataTable.Editor.defaults.i18n.edit.submit,
              className: 'btn btn-primary',
              fn: function () {
                editor.submit()
              }
            })
        })

        async function historyTable (id) {
          var dateHistory = await DateService.getHistory(id)
          dateHistory = dateHistory.data

          var table = '<table class="table table-striped table-sm" style="width: auto">' +
            '<thead class="thead-dark"><tr><th>Zeitpunkt</th><th>BenutzerIn</th><th>Feld</th><th>Wert</th></tr></thead>' +
            '<tbody>'
          dateHistory.forEach(h => {
            table += '<tr>'
            table += '<td>' + h.sChangeTS + '</td>'
            table += '<td>' + h.oUser.sLastname + ', ' + h.oUser.sFirstname + '</td>'
            table += '<td>' + h.oField.sTranslation + '</td>'
            table += '<td>' + h.oField.sFieldValue + '</td>'
            table += '</tr>'
          })

          table += '</tbody></table>'

          return table
        }

        async function history (id) {
          var table = await historyTable(id)
          return '<div class="ml-3"><h5>Historie</h5>' +
            table +
            '</div>'
        }

        $('#' + tableId).on('click', '.dt-history', async function (e) {
          e.preventDefault()
          var tr = $(this).closest('tr')
          var row = $('#' + tableId).DataTable().row(tr)
          var id = row.data().id

          if (row.child.isShown()) {
            row.child.hide()
          } else {
            var data = await history(id)
            row.child(data).show()
          }
        })
      }))
  }
}
</script>
<style scoped>
.input-group-text {
  background-color: var(--secondary) !important;
  color: #fff !important;
}
</style>
